import { ROUTES } from "../../../setup/constants";

export const NAVBAR_ITEMS = [
  { label: "lbl_nav_home_title", route: ROUTES.HOME },
  {
    label: "lbl_contracts_title",
    route: ROUTES.CONTRACTS_LIST,
  },
  {
    label: "lbl_my_wallet_title",
    route: ROUTES.PAYMENTS,
  },
];

export const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
